export const CFormFields = {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    DAY: 'day',
    MONTH: 'month',
    YEAR: 'year'
} as const;

export const CDateRegex = {
    DAY: /^(0[1-9]|[12][0-9]|3[01])$/,
    MONTH: /^(0[1-9]|1[0-2])$/,
    YEAR: /^\d{4}$/
} as const;

export const COnboardingCreateKidForm = "onboardingCreateKidForm" as const;

